import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../../../../consts/api";
import { http } from "../../../../../services/HttpService";

export const usePatientFiIntegration = (options = {}) => {
  const res = useQuery(
    [QUERY_KEYS.patientFi.getIntegration],
    () =>
      http.get(HTTP_ENDPOINTS.patientFiIntegration.getPatientFiIntegration()),
    { cacheTime: 0, select: (data) => data.data.data, ...options },
  );
  return res;
};
